/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var WrittenEventType;

(function (WrittenEventType) {
  WrittenEventType["BIND"] = "bind";
  WrittenEventType["OPENING_BALANCE"] = "opening_balance";
  WrittenEventType["POLICY_UPDATE"] = "policy_update";
  WrittenEventType["PREMIUM_CHANGE"] = "premium_change";
  WrittenEventType["POLICY_CANCEL"] = "policy_cancel";
  WrittenEventType["DISPUTE_LOST"] = "dispute_lost";
})(WrittenEventType || (WrittenEventType = {}));